import { useMemo } from 'react';
import { getCurrentMonth, getMonth, getNextMonth, getPreviousMonth, MonthData } from '../../../../utils/date';
import { UTCDate } from '@date-fns/utc';
import { Image } from '../../../../common/components/Image';
import { Link, useSearchParams } from 'react-router';

export type MonthSwitcherProps = {
  mode: 'FIXTURES' | 'RESULTS' | 'DEFAULT';
  initialMonth?: MonthData;
};

export function MonthSwitcher({ mode, initialMonth }: MonthSwitcherProps) {
  const [searchParams] = useSearchParams();
  const startDate = searchParams.get('startDate');
  const thisMonth = getCurrentMonth();

  let currentMonth = thisMonth;

  if (!startDate) {
    currentMonth = initialMonth ?? thisMonth;
  } else {
    const jsDate = new Date(startDate);
    const d = new UTCDate(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate());

    currentMonth = {
      ...getMonth(d),
      date: d,
    };
  }

  const previousMonth = getPreviousMonth(currentMonth.date);
  const nextMonth = getNextMonth(currentMonth.date);

  const prevParams = new URLSearchParams(searchParams);
  prevParams.set('startDate', previousMonth.startDate);
  prevParams.set('endDate', previousMonth.endDate);

  const nextParams = new URLSearchParams(searchParams);
  nextParams.set('startDate', nextMonth.startDate);
  nextParams.set('endDate', nextMonth.endDate);

  const showBackArrow = useMemo(() => {
    if (mode === 'FIXTURES') {
      if (currentMonth.date.getTime() > thisMonth.date.getTime()) {
        return true;
      }

      return previousMonth.date.getTime() >= thisMonth.date.getTime();
    }

    return true;
  }, [currentMonth, mode, previousMonth.date, thisMonth]);

  const showNextArrow = useMemo(() => {
    if (mode === 'RESULTS') {
      if (nextMonth.date.getTime() <= thisMonth.date.getTime()) {
        return true;
      }

      return nextMonth.date.getTime() <= currentMonth.date.getTime();
    }

    return true;
  }, [currentMonth.date, mode, nextMonth.date, thisMonth.date]);

  return (
    <div className="month-switcher">
      {showBackArrow && (
        <Link to={`?${prevParams.toString()}`}>
          <Image src="chevron-left.svg" alt={'previous month'} width={32} height={32} />
        </Link>
      )}
      <h3 className="month-switcher__name">{currentMonth.label}</h3>
      {showNextArrow && (
        <Link to={`?${nextParams.toString()}`}>
          <Image src="chevron-right.svg" alt={'next month'} width={32} height={32} />
        </Link>
      )}
    </div>
  );
}
